const API_BASE = process.env.REACT_APP_API_BASE || '';

async function request(path, options = {}) {
  const [pathWithQuery, hash = ''] = path.split('#');
  const [pathname, query = ''] = pathWithQuery.split('?');
  const normalizedPathname = pathname.startsWith('/api/') && !pathname.endsWith('/') ? `${pathname}/` : pathname;
  const apiPath = `${normalizedPathname}${query ? `?${query}` : ''}${hash ? `#${hash}` : ''}`;
  const url = `${API_BASE}${apiPath}`;
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  if (config.body && typeof config.body === 'object') {
    config.body = JSON.stringify(config.body);
  }

  const res = await fetch(url, config);
  const data = await res.json();

  if (!res.ok) {
    const err = new Error(data.error || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }

  return data;
}

export const api = {
  register(body) {
    return request('/api/auth/register', { method: 'POST', body });
  },

  sendEmailCode(body) {
    return request('/api/auth/send-email-code', { method: 'POST', body });
  },

  login(body) {
    return request('/api/auth/login', { method: 'POST', body });
  },

  forgotPassword(body) {
    return request('/api/auth/forgot-password', { method: 'POST', body });
  },

  resetPassword(body) {
    return request('/api/auth/reset-password', { method: 'POST', body });
  },

  verifyToken(token) {
    return request('/api/auth/verify', { method: 'POST', body: { token } });
  },

  updateProfile(body) {
    return request('/api/auth/profile', { method: 'POST', body });
  },

  getJin10(params = {}) {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        search.set(key, value);
      }
    });
    const query = search.toString();
    return request(`/api/jin10${query ? `?${query}` : ''}`, { method: 'GET' });
  },

  getMarketRadar() {
    return request('/api/market/radar', { method: 'GET' });
  },

  getGoldPrice(params = {}) {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        search.set(key, value);
      }
    });
    const query = search.toString();
    return request(`/api/gold-price${query ? `?${query}` : ''}`, { method: 'GET' });
  },

  getGoldVegasTrend() {
    return request('/api/gold/vegas-trend', { method: 'GET' });
  },
};
